import { defineXray } from "../src/xray/manifest.js";
import { extractSqlOps, describeMissing } from "../extractors/sql/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/sql/spec.js";

export default defineXray({
  id: "sql",
  label: "Tables",
  title: "What agents asked databases directly and what they changed — grouped by the table, with the "
    + "last row count seen and any write nobody verified afterwards",

  consumer: "someone reviewing what an agent read out of, or wrote into, a real database",
  decision: "whether a conclusion rests on a query that answered, one that errored, or a write nobody checked",

  // The table is a thing a reader knows without knowing the session, and it
  // outlives every session touching it. The existing Queries tab covers the
  // analytics API and deliberately excludes shell, so shell SQL had no reading.
  // MEASURED AS FORMATTING. a database client already says what it queried; the lens adds an outcome flag, and the table does not accumulate into a question a scope answers
  tab: false,
  tabReason: "a database client already says what it queried; the lens adds an outcome flag, and the table does not accumulate into a question a scope answers",
  feed: { domain: "sql" },
  extract: extractSqlOps, collect, group: build, groupBy, anchor, ignore,
  emptyNote: "No direct database work in this window",
  lineageReason: "queryNodes in the host's traceProvenance already owns queried data and holds the query.* node kinds. Folding this lens in means moving TWO things it knows and queryNodes does not: it resolves the TABLE as the identity (`<database>.<table>`), where a query.* ref is `<engine>:<target>` — a schema coordinate citation() refuses — and it splits read / write / schema, flagging a write no later read verified",

  explainMissing: describeMissing,
});
